import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../auth";
//import "./styles.css";
import md5 from "md5";
import CryptoJS from "crypto-js";
import api from "../api";
import Loading from "./loading/loading";
import toastr from "toastr";

function Menu() {
  const navigate = useNavigate();
  const { setLogado } = useContext(AuthContext);
  const [senha, setSenha] = useState("");
  const [senhaR, setSenhaR] = useState("");

  function decryptData(encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, "AFM-Distrato");
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  function alterarSenha(event) {
    setSenha(md5(event.target.value));
  }

  function alterarSenhaR(event) {
    setSenhaR(md5(event.target.value));
  }

  function ModificarSenha() {
    api
      .put("/senha", {
        SENHA: senhaR,
        ID_USUARIO: decryptData(sessionStorage.getItem("id_usuario")),
      })
      .then(function (AxiosResponse) {
        Loading.hide();
        if (AxiosResponse.data.SUCCESS !== true) {
          toastr.error("Erro ao alterar senha!");
        } else if (AxiosResponse.data.SUCCESS === true) {
          toastr.success(`Senha alterada com sucesso`, "Sucesso.");
        }
      })
      .catch(function (error) {
        Loading.hide();
        toastr.error(error, "Erro ao realizar login!");
      });

    document.getElementById("inputSenha").value = "";
    document.getElementById("passwordR").value = "";
    setSenha("");
    setSenhaR("");
  }

  function Sair() {
    sessionStorage.setItem("logado", "N");
    setLogado(false);
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-white fixed-top menu">
      <div class="container-fluid">
        <img
          src="../../img/logotipoafm.png"
          alt=""
          width="100px"
          height="30"
          className="d-inline-block align-text-top logo"
          onClick={() => navigate("/admin/home")}
        />
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <ul className="navbar-nav">
            <li className="nav-item">
              <button
                className="nav-link active"
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                }}
                onClick={() => navigate("/admin/home")}
              >
                Início
              </button>
              {/* <a href="/admin/home" className="nav-link active">
                Início
              </a> */}
            </li>
            {/* <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle active" id="navbarDropdownMenuLink" href="#Solucoes"
                            role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Cadastros
                        </a>
                        <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <li><a href="/cadastros/funcionario" className="dropdown-item">Funcionário</a></li>
                            <li><a href="/cadastros/paciente" className="dropdown-item">Paciente</a></li>
                        </ul>
                    </li>
                    <li className="nav-item">
                        <a href="/agenda" className="nav-link active">Agenda</a>
                    </li>
                    <li className="nav-item">
                        <a href="/atendimentos" className="nav-link active">Atendimentos</a>
                    </li> */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle active"
                id="navbarDropdownMenuLink"
                href="#MeuEspaço"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Meu Espaço
              </a>
              <ul
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li>
                  <a
                    href="#"
                    onClick={() => window.$("#staticBackdrop").modal("show")}
                    className="dropdown-item"
                  >
                    Alterar Senha
                  </a>
                </li>
                <li>
                  <a href="/" className="dropdown-item" onClick={() => Sair()}>
                    Sair
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Modal de Alteração de Senha */}
        <div
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="false"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="false"
        >
          <div className="opaco">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="row">
                    <h5
                      className="modal-title col-md-12 tituloC"
                      id="TituloModalLongoExemplo"
                    >
                      Altere sua Senha
                    </h5>
                    <span className="col-md-12 subTituloC">
                      Preencha os campos abaixo para alterar sua senha:
                    </span>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form className="container">
                    <div className="row">
                      <div className="col-md-12 p-1">
                        <b className="labelDescC">Nova Senha</b>
                        <input
                          type="password"
                          className="form-control form-control-sm inputsDados"
                          id="inputSenha"
                          onChange={alterarSenha}
                        />
                      </div>
                      <div className="col-md-12 p-1">
                        <b className="labelDescC">Repita sua Nova Senha</b>
                        <div className="input-group">
                          <input
                            type="password"
                            id="passwordR"
                            onChange={alterarSenhaR}
                            className="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    onClick={() => ModificarSenha()}
                    type="button"
                    className="btn btn-success"
                  >
                    Alterar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
export default Menu;
